import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahReports } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

interface AcfrIncomeBucket {
  commonwealth: number;
  participant: number;
}

interface AcfrIncomeBucketWithCareM extends AcfrIncomeBucket {
  care_mgmt: number;
}

interface AcfrIncomeBucketWithProviderAdmin extends AcfrIncomeBucket {
  provider_admin: number;
}

interface AcfrReconStatusBucket {
  count: number;
  commonwealth: number;
  participant: number;
}

interface AcfrUnclaimedSupplierInvoiceBucket {
  count: number;
  commonwealth: number;
}

export interface AcfrReportResponse {
  period: { from: string; to: string };
  income: {
    CLINICAL: AcfrIncomeBucket;
    INDEPENDENCE: AcfrIncomeBucket;
    EVERYDAY_LIVING: AcfrIncomeBucket;
    CARE_MGMT_MAIN: AcfrIncomeBucket;
    RESTORATIVE_CARE: AcfrIncomeBucketWithCareM;
    END_OF_LIFE: AcfrIncomeBucketWithCareM;
    ATHM: AcfrIncomeBucketWithProviderAdmin;
  };
  participant_topups: number;
  other_income: number;
  totals: { commonwealth: number; participant: number; total_income: number };
  unmapped_count: number;
  reconciliation_status: {
    current: AcfrReconStatusBucket;
    amended: AcfrReconStatusBucket;
    adjusted: AcfrReconStatusBucket;
  };
  unclaimed_supplier_invoice: AcfrUnclaimedSupplierInvoiceBucket;
}

interface AcfrReportParams {
  date_from: string;
  date_to: string;
}

export const sahReportsApi = createApi({
  reducerPath: 'sahReportsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahReports }),
  tagTypes: ['acfr-report'],
  endpoints: (builder) => ({
    getAcfrReport: builder.query<AcfrReportResponse, AcfrReportParams>({
      query: (params) => ({ url: '/acfr', method: 'GET', params }),
      providesTags: [{ type: 'acfr-report', id: 'ACFR' }],
      transformResponse: (payload) => unwrap<AcfrReportResponse>(payload),
    }),
  }),
});

export const { useLazyGetAcfrReportQuery } = sahReportsApi;
